 /// <reference path="../../_ext/Editors/MFGTransBOMGridEditor.ts" />

namespace TabAurous.JobWork {
    import fld = JobWorkBOMRow.Fields;

    @Serenity.Decorators.registerClass()
    export class JobWorkBOMEditor extends _Ext.MFGTransBOMGridEditor<JobWorkBOMRow> {
        protected getColumnsKey() { return "JobWork.JobWorkBOM"; }
        protected getDialogType() { return JobWorkBOMDialog; }
        protected getLocalTextPrefix() { return JobWorkBOMRow.localTextPrefix; }
        protected form: JobWorkBOMForm; 
        public PartyId: number;
        public RateListId: number;
        public LaborListId: number;
        public StoneMarkup: number;
        public LaborMarkup: number;

        constructor(container: JQuery) {
            super(container); 
        }
        private autoSize;
        // **** to Call shortcut key in Main Window
        protected createToolbar(buttons: Serenity.ToolButton[]): void {
            var toolbarDiv = $('<div class="grid-toolbar"></div>').appendTo(this.element);
            this.toolbar = new Serenity.Toolbar(toolbarDiv, { buttons: buttons, hotkeyContext: document.getElementsByTagName('body')[0] });
        }
        protected createSlickGrid(): Slick.Grid {
            let grid = super.createSlickGrid();
            this.autoSize = new Slick.AutoColumnSize();
            grid.registerPlugin(this.autoSize);
            return grid;
        }

        // #region Column Add -Remove
        protected getColumns() {

            var columns = super.getColumns();
            var amt = ctx => ColumnFormatter.AmountFormatter(ctx, this);
            Q.first(columns, x => x.field === fld.BomRate).format = amt;
            return columns;
        }
 

        protected getButtons() {
            let buttons = super.getButtons();
            var grid = OMS.RawMaterialMasterSelectGrid;
            // grid.apply(this.rowSelection = new Serenity.GridRowSelectionMixin(this));
            //grid.apply(this.getColumns = (Serenity.GridRowSelectionMixin.createSelectColumn(() => this.rowSelection));

            buttons.push({
                title: "Select Products",
                cssClass: "add-button",
                onClick: () => {
                    var pickerDialog = new _Ext.GridItemPickerDialog({
                        gridType: grid, multiple: true,
                        preSelectedKeys: this.value.map(k => k.ProductId)
                    });

                    pickerDialog.onSuccess = (selectedItems: any[]) => {
                        let selectedItems2 = selectedItems.filter(t => { return !Q.any(this.view.getItems(), n => n.ProductId == t.ProductId) });
                        //alert('Length' + selectedItems.length);
                        var purchasedetails = [];
                        var ratelistId = this.RateListId;
                        //alert(selectedItems2.length);
                        selectedItems2.forEach(function (value) {
                            var prdid = value.ProductId;
                            //alert(prdid);
                            var atb = value.AttributeId;
                            var atbCode = value.Attribute;
                            var ItmTpy = value.ItemType;
                            var ItmTpyId = value.ItemTypeId;
                            var TypeID = value.CategoryId;
                            var SubTypeID = value.SubCategoryId;
                            var SubType = value.SubCategoryCode;
                            var Karat = value.KaratCode;
                            var KaratId = value.KaratId;
                            var StoneColorID = value.StoneColorId;
                            var MetalColorId = value.MetalColorId;
                            var CalcOn = value.CalcOnId;

                            var ShapeID = value.ShapeId;
                            var Quality = value.QualityCode;
                            var QualityId = value.QualityId;
                            var Purity =value.Purity;
                            var Pieces = 0;
                            var Weight = 0.01;
                            var Rate = 0;
                            var Amount = 0;

                            if (SubTypeID == 301 || SubTypeID == 302 || SubTypeID == 303 || SubTypeID == 304) {
                                var MetalRate = GetItemRateHelper.GetGetMetalRate(SubTypeID);
                                Rate = MetalRate;
                                Amount = Rate * Weight * Purity;

                            }
                            else {
                                var ItemRate = GetItemRateHelper.GetPurchaseRate(atb, ratelistId);
                                Rate = ItemRate;
                                Pieces = 1;
                                if (CalcOn == 3) {
                                    Amount = Rate * Pieces
                                }
                                else {
                                    Amount = Rate * Weight;
                                }
                            }


                            var Bom: JobWorkBOMRow = {
                                BOMProductId: prdid,

                                ProductCode: value.ProductCode,
                                BOMAttributeId: value.AttributeId,
                                Attribute: atbCode,
                                ItemType: ItmTpy,
                                ItemTypeId: ItmTpyId,


                                StoneColorId: StoneColorID,
                                MetalColorId: MetalColorId,
                                KaratId: KaratId,

                                BomRate: Rate,
                                Pieces: value.Pieces,
                                Weight: value.Weight,
                                CalcOn: value.CalcOnId,
                                ShapeId: ShapeID,
                                QualityId: QualityId,

                                Purity: Purity,
                                BomAmount: Amount


                                //othpcs: value.other_pieces,
                                //othwt: value.other_weight,
                                //clspcs: value.color_stone_pieces,
                                //clswt: value.color_stone_weight,
                                //netwt: value.net_weight,
                                //netamount: value.amount,
                                //diapcs: value.diamond_pieces,
                                //diawt: value.diamond_weight,
                                //bomdetails: bomdetails
                            };
                            purchasedetails.push(Bom);

                        });


                        for (let purchaseDetail of purchasedetails) {
                            purchaseDetail[this.getIdProperty()] = "`" + this.nextId++;
                            //alert('ID ' + purchaseDetail.PrdBomId);
                            var x = purchaseDetail;
                            this.view.addItem(purchaseDetail);

                        }

                    }

                    pickerDialog.dialogOpen();
                }
            });

            return buttons;
        }


        protected markupReady() {
            super.markupReady();
            if (this.autoSize != null) {
                this.autoSize.resizeAllColumns();
            }
        }
        /*protected getButtons(): Serenity.ToolButton[] {
            var buttons = super.getButtons();
            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "add-button"), 1);

            return buttons;
        }*/

    }
}